export const new_winners = [
  {
    username: "Maranza44",
    email: "maranzaita@gmail.com",
    address: "0x0c846be023c51cbb2b46e3b33369aa323fa7f055",
    rewards: 1089,
  },
  {
    username: "xLunatiCx",
    email: "kage10.zero@gmail.com",
    address: "0xe2abdfd0ed4cb4e025f5c86853c8706c230cb343",
    rewards: 1215,
  },
  {
    username: "alex19",
    email: "alexsonn19999@gmail.com",
    address: "0x11a9550ae67fc85554933d26eec9715d01483018",
    rewards: 110,
  },
  {
    username: "SlayerV",
    email: "laurenbuse1978-gamers@yahoo.com",
    address: "0x110d7a328d78d74da3cbb801c66fbaa656f326c5",
    rewards: 451,
  },
  {
    username: "AronChl",
    email: "aronchl127@gmail.com",
    address: "0x1acf5001aaee58b7d68ff529dc1b408d1c94b3e2",
    rewards: 264,
  },
  {
    username: "Supremus93",
    email: "blo.pa@yahoo.com",
    address: "0x2d0202be7d4ed55c18b79d7f3a843445875f4cbf",
    rewards: 286,
  },
  {
    username: "Pulse_Rift",
    email: "boliskotes@gmail.com",
    address: "0x2caf1926727415cf8e6a22bdc779e8635a490304",
    rewards: 632,
  },
  {
    username: "theABHISHEK",
    email: "abhisheksp012@gmail.com",
    address: "0x9c48a64311aa85f43b680b204d757790927f8a02",
    rewards: 291,
  },
  {
    username: "0n4nd0ff",
    email: "onandoff@libero.it",
    address: "0x9cee52aebb748f68c8b08ab28ce01d33e0b8f1b4",
    rewards: 181,
  },
  {
    username: "McPaul",
    email: "pdelaguila777@gmail.com",
    address: "0x9f3c6cbc7353d6591b4cc2f1c02e4344b3a0a949",
    rewards: 286,
  },
  {
    username: "Gl1tchMast3r ",
    email: " kosb38036@gmail.com",
    address: "0xC971BD0f1B86A9Ec9109d132B9149847087CFa6D",
    rewards: 643,
  },
  {
    username: "gh_rocks",
    email: "gh_rocks@colission.com",
    address: "0xafee8b12dc6db3207b3836eff1fb53373458480e",
    rewards: 253,
  },
  {
    username: "SharkOwO",
    email: "threeyear3yrs@gmail.com",
    address: "0xd75640f91714340bfa275dc3d49e2b1a792eefda",
    rewards: 11,
  },
  {
    username: "V0id",
    email: "marseliowalles@gmail.com",
    address: "0x4ef8c39126b334d734498b959ba55a3cadf72bdd",
    rewards: 693,
  },
  {
    username: "Vasyl Dash ",
    email: "vasyavd18@gmail.com",
    address: "0xe53af7fd3c2629ff427adf9c870fbb0e961f989f",
    rewards: 225,
  },
  {
    username: "Istclassass",
    email: "amelia_drew_209@icloud.com",
    address: "0xf7daa481ca09b2818552c9c5d56d5cc88cf18047",
    rewards: 330,
  },
];

export const new_winners_gem = [
  {
    username: "Maranza44",
    email: "maranzaita@gmail.com",
    address: "0x0c846be023c51cbb2b46e3b33369aa323fa7f055",
    reward: 44,
  },
  {
    username: "alex19",
    email: "alexsonn19999@gmail.com",
    address: "0x11a9550ae67fc85554933d26eec9715d01483018",
    reward: 25,
  },
  {
    username: "AronChl",
    email: "aronchl127@gmail.com",
    address: "0x1acf5001aaee58b7d68ff529dc1b408d1c94b3e2",
    reward: 42.5,
  },
  {
    username: "Pulse_Rift",
    email: "boliskotes@gmail.com",
    address: "0x2caf1926727415cf8e6a22bdc779e8635a490304",
    reward: 8.5,
  },
  {
    username: "Supremus93",
    email: "blo.pa@yahoo.com",
    address: "0x2d0202be7d4ed55c18b79d7f3a843445875f4cbf",
    reward: 27.5,
  },
  {
    username: "CeZaR112",
    email: "cezar.cs93@gmail.com",
    address: "0x3612928eaa3d07c74e3025d19f3f1ce91993d4de",
    reward: 20.5,
  },
  {
    username: "V0id",
    email: "marseliowalles@gmail.com",
    address: "0x4ef8c39126b334d734498b959ba55a3cadf72bdd",
    reward: 23.5,
  },
  {
    username: "FreakAngel",
    email: "x3mator@gmail.com",
    address: "0x936d5c110f9e66500983ddeba6472aed5b25e29f",
    reward: 46,
  },
  {
    username: "theABHISHEK",
    email: "abhisheksp012@gmail.com",
    address: "0x9c48a64311aa85f43b680b204d757790927f8a02",
    reward: 2,
  },
  {
    username: "0n4nd0ff",
    email: "onandoff@libero.it",
    address: "0x9cee52aebb748f68c8b08ab28ce01d33e0b8f1b4",
    reward: 27,
  },
  {
    username: "McPaul",
    email: "pdelaguila777@gmail.com",
    address: "0x9f3c6cbc7353d6591b4cc2f1c02e4344b3a0a949",
    reward: 20.5,
  },
  {
    username: "gh_rocks",
    email: "gh_rocks@colission.com",
    address: "0xafee8b12dc6db3207b3836eff1fb53373458480e",
    reward: 25.5,
  },
  {
    username: " kosb38036@gmail.com",
    email: "Gl1tchMast3r ",
    address: "0xC971BD0f1B86A9Ec9109d132B9149847087CFa6D",
    reward: 7,
  },
  {
    username: "JokongXIII",
    email: "jokongscholar5@gmail.com",
    address: "0xc9bfd6e41ee5fb871fa8f100938f30ad11927b1f",
    reward: 14,
  },
  {
    username: "SharkOwO",
    email: "threeyear3yrs@gmail.com",
    address: "0xd75640f91714340bfa275dc3d49e2b1a792eefda",
    rewards: 5.5,
  },
  {
    username: "Cervez86",
    email: "mateusz.liwowski@wp.pl",
    address: "0x3530aad7f63c4b6d7c8bf1e43b5431408555c4d1",
    rewards: 3,
  },
  {
    username: "xLunatiCx",
    email: "kage10.zero@gmail.com",
    address: "0xe2abdfd0ed4cb4e025f5c86853c8706c230cb343",
    reward: 42.5,
  },
  {
    username: "Vasyl Dash ",
    email: "vasyavd18@gmail.com",
    address: "0xe53af7fd3c2629ff427adf9c870fbb0e961f989f",
    reward: 41.5,
  },
  {
    username: "Istclassass",
    email: "amelia_drew_209@icloud.com",
    address: "0xf7daa481ca09b2818552c9c5d56d5cc88cf18047",
    reward: 1,
  },
];
